module.exports = __webpack_public_path__ + "static/media/MobileSellkeyFunction02.1161110d.png";